import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../../components/Learner/Layout';
import ReportHeader from '../../../components/Learner/ReportPage/ReportHeader';
import ReportStats from '../../../components/Learner/ReportPage';
import { getLearnerReport } from '../../../services/reportApi';
import './styles.css';

const LearnerReport = () => {
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Check if user is logged in
        const token = localStorage.getItem('token');
        if (!token) {
          console.log('❌ No token found, redirecting to login...');
          navigate('/learner/login');
          return;
        }

        console.log('📊 Fetching learner report...');
        
        // Call the getLearnerReport API function (learner-id from token)
        const result = await getLearnerReport();
        
        if (result.success) {
          console.log('✅ Report data received:', result.data);
          setReportData(result.data.data || result.data);
        } else {
          console.error('❌ Failed to fetch report:', result.message);
          setError(result.message || 'Failed to load report data');
        }
      } catch (err) {
        console.error('❌ Error fetching report data:', err);
        setError(err.message || 'Failed to load report data. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchReportData();
  }, [navigate]);

  return (
    <Layout>
      <div className="report-page-container">
        <ReportHeader />
        <ReportStats 
          data={reportData} 
          loading={loading} 
          error={error} 
        />
      </div>
    </Layout>
  );
};

export default LearnerReport;

